import { TYPES } from './types';
import { k3agentService } from '../services';

// Get all agents
export const getK3Agents = (query = {}) => async dispatch => {
  try {
    const res = await k3agentService.getK3Agents(query);
    dispatch({
      type: TYPES.ACTION_GET_K3AGENTS_SUCCESS,
      payload: {
        agents: res.data.data.agents,
        total: res.data.data.total
      }
    });
  } catch (err) {
    dispatch({
      type: TYPES.GET_K3AGENTS_FAILURE,
      payload: err.response?.data || { message: 'Error getting agents' }
    });
  }
};

// Get a single agent
export const getK3Agent = (id) => async dispatch => {
  try {
    const res = await k3agentService.getK3Agents({ id });
    dispatch({
      type: TYPES.ACTION_GET_K3AGENT_SUCCESS,
      payload: res.data.data.agents[0]
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3AGENT_FAIL,
      payload: err.response?.data || { message: 'Error getting agent' }
    });
  }
};

// Set agents (create/update/delete)
export const setK3Agents = (agents, query = {}) => async dispatch => {
  try {
    const res = await k3agentService.setK3Agents(agents, query);
    dispatch({
      type: TYPES.ACTION_SET_K3AGENTS_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_SET_K3AGENTS_FAIL,
      payload: err.response?.data || { message: 'Error setting agents' }
    });
  }
};

// Get agent tasks
export const getK3AgentTasks = (taskIds) => async dispatch => {
  try {
    const res = await k3agentService.getK3Tasks(taskIds);
    dispatch({
      type: TYPES.ACTION_GET_K3AGENT_TASKS_SUCCESS,
      payload: res.data.data.tasks
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3AGENT_TASKS_FAIL,
      payload: err.response?.data || { message: 'Error getting agent tasks' }
    });
  }
};

// Get agent logs
export const getK3AgentLogs = (params) => async dispatch => {
  try {
    const res = await k3agentService.getK3Logs(params);
    dispatch({
      type: TYPES.ACTION_GET_K3AGENT_LOGS_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3AGENT_LOGS_FAIL,
      payload: err.response?.data || { message: 'Error getting agent logs' }
    });
  }
};

// Assign job to agent
export const assignK3AgentJob = (jobData) => async dispatch => {
  try {
    const res = await k3agentService.assignJob(jobData);
    dispatch({
      type: TYPES.ACTION_ASSIGN_K3AGENT_JOB_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_ASSIGN_K3AGENT_JOB_FAIL,
      payload: err.response?.data || { message: 'Error assigning job' }
    });
  }
};

// Delete agent task
export const deleteK3AgentTask = (taskId) => async dispatch => {
  try {
    const res = await k3agentService.deleteTask(taskId);
    dispatch({
      type: TYPES.ACTION_DELETE_K3AGENT_TASK_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_DELETE_K3AGENT_TASK_FAIL,
      payload: err.response?.data || { message: 'Error deleting task' }
    });
  }
};

// Update agent task
export const updateK3AgentTask = (taskData) => async dispatch => {
  try {
    const res = await k3agentService.updateTask(taskData);
    dispatch({
      type: TYPES.ACTION_UPDATE_K3AGENT_TASK_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_UPDATE_K3AGENT_TASK_FAIL,
      payload: err.response?.data || { message: 'Error updating task' }
    });
  }
}; 